<div class="multi-link-list"></div>
<button class="button add-link-item"><i class="icon-plus"></i> {{t "editor.inspector.properties.link.addLanguage"}}</button>
